$(function () {
    if ($("#property-detail").length) {

        var propertyIdParameter = '';
        if ($('#property-detail-property-id').length) {
            propertyIdParameter = $('#property-detail-property-id').val();
        }

        $(window).on('load', function () {
            // $('.slideshow-thumbnail-item .image-background-container').each(function () {
            //     $(this).css('background-image', $(this).data('image-to-load'));
            // });
        });


        function mobileHeaderButtons() {

            let btns = $('.overlay-btn-row .btn');

            // if btns.length is an odd number, add full-width-btn to the last button
            if (btns.length % 2 !== 0) {
                btns.last().addClass('full-width-mobile');
            }

        }

        mobileHeaderButtons();


        $('.view-interactive-map-button').on('click', function () {
            window.helpers.gaEvent('Property Detail', 'view-interactive-map', propertyIdParameter)
        });

        $('.view-matterport-video-button').on('click', function () {
            window.helpers.gaEvent('Property Detail', 'view-matterport', propertyIdParameter);
        });

        $('.download-brochure-link-logged-in').on('click', function () {

            var propertyId = $(this).data('property-id'),
                propertyName = $(this).data('property-name'),
                propertyLink = $(this).data('property-link'),
                userId = $('#current-user-id').val();

            if ($(this).hasClass('download-brochure-no-gate')) {

                $.post("/wp/wp-admin/admin-ajax.php", {
                    'action': 'download_brochure',
                    'property_id': propertyId,
                    'user_id': userId,
                    'property_name': propertyName,
                    'property_link': propertyLink
                }, function (data) { });

                window.helpers.gaEvent('Brochures', 'brochure-downloaded-no-gate', propertyId);

            } else {

                $.post("/wp/wp-admin/admin-ajax.php", {
                    'action': 'download_brochure',
                    'property_id': propertyId,
                    'user_id': userId,
                    'property_name': propertyName,
                    'property_link': propertyLink
                }, function (data) { });

                window.helpers.gaEvent('Property Detail', 'brochure-downloaded', propertyId);
                window.helpers.gaEvent('Brochures', 'brochure-downloaded', propertyId);

            }

        });

        if (window.helpers.readCookie('current_search_string') !== null) {
            var currentSearchString = window.helpers.readCookie('current_search_string');
            $('#property-detail-back-button').attr('href', currentSearchString);
        }

        $(document).on('click', '#detailTabs .nav-link', function () {
            window.helpers.smoothScroll($('#details-tab-container'), 100);
        });

        $(document).on('click', '.nav-link', function () {
            $('.nav-link').not($(this)).removeClass('active show');
        });

        $('.to-set-tab').on('click', function () {

            let tab = $(this).data('tab');
            tab += ($(window).width() < 992) ? 'TabMobile' : 'Tab';
            $('#' + tab).click();

        });

        // $('.to-tracts-tab').on('click', function () {
        //     $('#propertyTractsTab').click();
        //     window.helpers.smoothScroll($('#details-tab-container'), 100);
        // });
        //
        // $('.to-location-tab').on('click', function () {
        //     $('#localeTab').click();
        //     window.helpers.smoothScroll($('#details-tab-container'), 100);
        // });
        //
        // $('.to-property-details-tab').on('click', function () {
        //     $('#propertyDetailsTab').click();
        //     window.helpers.smoothScroll($('#details-tab-container'), 100);
        // });
        //
        // $('.to-recreational-amenities-tab').on('click', function () {
        //     $('#recreationalAmenitiesTab').click();
        //     window.helpers.smoothScroll($('#details-tab-container'), 100);
        // });
        //
        // $('.to-general-operations-tab').on('click', function () {
        //     $('#generalOperationsTab').click();
        //     window.helpers.smoothScroll($('#details-tab-container'), 100);
        // });
        //
        // $('.to-overview-tab').on('click', function () {
        //     $('#overviewTab').click();
        //     window.helpers.smoothScroll($('#details-tab-container'), 100);
        // });
        //
        // $('.to-documents-tab').on('click', function () {
        //     $('#tractDocumentsTab').click();
        //     window.helpers.smoothScroll($('#details-tab-container'), 100);
        // });




        // END Broker

        if (window.helpers.getQueryVariable('video') === "true") {
            $('#video-modal').modal('show');

            if ($('#video-status').val() === "single") {
                var iframes = $('#video-modal').find('iframe'),
                    iframe = iframes[0];

                setTimeout(function () {
                    // window.helpers.startIframe(iframe);
                }, 300);
            }
        }

        if($('#matterport-modal').length) {

            var matterportSlider = $('#matterport-slider').slick({
                // lazyLoad: 'ondemand',
                fade: true,
                prevArrow: '<button type="button" class="slick-prev"><img src="/assets/img/icon-arrow.svg" alt=""></button>',
                nextArrow: '<button type="button" class="slick-next"><img src="/assets/img/icon-arrow.svg" alt=""></button>',
                adaptiveHeight: false
            });

            matterportSlider.on('afterChange', function (slick, currentSlide) {
                window.helpers.updateUrl('matterport-slide', currentSlide.currentSlide);
            });

            $('#matterport-modal').on('shown.bs.modal', function () {
                $(window).resize();
                window.helpers.updateUrl('showing-matterport', 'true');
                // $('body').css('overflow', '');
            });

            $('#matterport-modal').on('hide.bs.modal', function () {
                $(window).resize();
                window.helpers.updateUrl('showing-matterport', 'false');
                $('body').css('overflow', '');
            });

            function sizeMobileViews() {

                if($(window).width() < 992) {
                    $('#matterport-modal').css('height', $(window).height());
                    $('.matterport-tour-slide-item').css('height', $(window).height() - 50);
                    $('.matterport-tour-slide-item figure').css('height', $(window).height() - 50);
                }

            }

            sizeMobileViews();
            $(window).on('resize', function () {
                sizeMobileViews();
            });

            if(window.helpers.getQueryVariable('showing-matterport') === 'true') {
                $('#matterport-modal').modal('show');

                if(window.helpers.getQueryVariable('matterport-slide')) {
                    setTimeout(function () {
                        matterportSlider.slick('slickGoTo', window.helpers.getQueryVariable('matterport-slide'));
                    }, 300);
                }
            }

        }

        if ($('#photo-gallery-modal').length) {
            var galleryIsLoaded = false;

            $('#photo-gallery-modal').imagesLoaded(function () {

                if (window.helpers.getQueryVariable('gallery') === "true") {
                    $('#photo-gallery-modal-thumbnails').modal('show');

                    setTimeout(function () {
                        photoGallerySlideshow.slick('slickGoTo', 0);
                    }, 500)
                }

                $(document).on('keydown', function (e) {
                    if (e.keyCode === 37) {
                        photoGallerySlideshow.slick('slickPrev');
                    }
                    if (e.keyCode === 39) {
                        photoGallerySlideshow.slick('slickNext');
                    }
                });

                var photoGallerySlideshow = $('#photo-gallery-slideshow').slick({
                    lazyLoad: 'ondemand',
                    fade: true,
                    prevArrow: '<button type="button" class="slick-prev"><img src="/assets/img/icon-arrow.svg" alt=""></button>',
                    nextArrow: '<button type="button" class="slick-next"><img src="/assets/img/icon-arrow.svg" alt=""></button>',
                    adaptiveHeight: false
                });

                var maxHeight = $(window).height() * .9;

                var checkDialog = $('#photo-gallery-modal').find('.modal-dialog'),
                    slideWidth = checkDialog.actual('width');

                photoGallerySlideshow.on('lazyLoaded', function (event, slick, image, imageSource) {
                    var height = $(image).actual('height'),
                        width = $(image).actual('width');

                    if ($(window).width() > 768) {

                        if (width > height) {

                            // If the image is landscape, proceed with other checks

                            // Check what the new height would be after being resized via a width 100%
                            var adjustedHeight = (slideWidth / width) * height;

                            if (adjustedHeight > maxHeight) {

                                // If the adjusted height is greater than the max-height, set based on height, and not on width
                                $(image).css({ 'height': maxHeight, 'width': 'auto', 'max-width': '100%', 'margin': '0 auto' });

                            } else {

                                // If the adjusted height is still within the max-height, find out the up/down centering margin that is needed
                                var remainingHeight = maxHeight - adjustedHeight,
                                    topBottomMargin = (remainingHeight / 2) + 'px';

                                $(image).css({
                                    'height': 'auto',
                                    'width': '100%',
                                    'max-width': '100%',
                                    'margin': topBottomMargin + ' auto'
                                });

                            }

                        } else {

                            // If the image is portrait or square, set the height to full height and center it
                            $(image).css({ 'height': maxHeight, 'width': 'auto', 'max-width': '100%', 'margin': '0 auto' });

                        }

                    } else {

                        // On mobile, set all images to full width, height auto
                        $(image).css({ 'height': 'auto', 'width': '100%' });

                    }

                });

                $('.slideshow-thumbnail-item').on('click', function () {
                    if($(this).parent().hasClass('tract-gallery-slideshow-thumbnails')) return;
                    var imageIndex = $(this).data('image-index');
                    $('#photo-gallery-modal').modal('show');

                    setTimeout(function () {
                        photoGallerySlideshow.slick('slickGoTo', imageIndex);
                    }, 500);
                });

                $('#photo-gallery-modal-thumbnails').on('shown.bs.modal', function () {
                    $('.slideshow-thumbnail-item .image-background-container').each(function () {
                        if (!$(this).hasClass('image-has-been-loaded')) {
                            $(this).css('background-image', 'url("' + $(this).data('image-to-load') + '")');
                            $(this).addClass('image-has-been-loaded');
                        }
                    });

                    window.helpers.updateUrl('gallery', 'true');

                    window.helpers.gaEvent('Property Detail', 'view-gallery', propertyIdParameter);
                });

                $('#photo-gallery-modal-thumbnails').on('hidden.bs.modal', function () {
                    window.helpers.updateUrl('gallery', 'false');
                });

                $('#photo-gallery-modal').on('shown.bs.modal', function () {
                    $('#property-hero').addClass('gallery-is-open');

                    if (!galleryIsLoaded) {
                        setTimeout(function () {
                            photoGallerySlideshow.slick('setPosition', 0);
                        }, 500);
                        galleryIsLoaded = true;
                    }
                });

                $('#video-modal').on('shown.bs.modal', function () {
                    window.helpers.gaEvent('Property Detail', 'view-video', propertyIdParameter);
                });

                $('#photo-gallery-modal').on('hidden.bs.modal', function () {
                    $('#property-hero').removeClass('gallery-is-open');
                    $('body').addClass('modal-open');
                });
            });
        }

        if ($('#hunting-photo-gallery-modal').length) {
            var huntingGalleryIsLoaded = false;

            $('#hunting-photo-gallery-modal').imagesLoaded(function () {

                if (window.helpers.getQueryVariable('hunting-gallery') === "true") {
                    $('#hunting-photo-gallery-modal-thumbnails').modal('show');

                    setTimeout(function () {
                        huntingPhotoGallerySlideshow.slick('slickGoTo', 0);
                    }, 500)
                }

                $(document).on('keydown', function (e) {
                    if (e.keyCode === 37) {
                        huntingPhotoGallerySlideshow.slick('slickPrev');
                    }
                    if (e.keyCode === 39) {
                        huntingPhotoGallerySlideshow.slick('slickNext');
                    }
                });

                var huntingPhotoGallerySlideshow = $('#hunting-photo-gallery-slideshow').slick({
                    lazyLoad: 'ondemand',
                    fade: true,
                    prevArrow: '<button type="button" class="slick-prev"><img src="/assets/img/icon-arrow.svg" alt=""></button>',
                    nextArrow: '<button type="button" class="slick-next"><img src="/assets/img/icon-arrow.svg" alt=""></button>',
                    adaptiveHeight: false
                });

                var maxHeight = $(window).height() * .9;

                var checkDialog = $('#hunting-photo-gallery-modal').find('.modal-dialog'),
                    slideWidth = checkDialog.actual('width');

                huntingPhotoGallerySlideshow.on('lazyLoaded', function (event, slick, image, imageSource) {
                    var height = $(image).actual('height'),
                        width = $(image).actual('width');

                    if ($(window).width() > 768) {

                        if (width > height) {

                            // If the image is landscape, proceed with other checks

                            // Check what the new height would be after being resized via a width 100%
                            var adjustedHeight = (slideWidth / width) * height;

                            if (adjustedHeight > maxHeight) {

                                // If the adjusted height is greater than the max-height, set based on height, and not on width
                                $(image).css({ 'height': maxHeight, 'width': 'auto', 'max-width': '100%', 'margin': '0 auto' });

                            } else {

                                // If the adjusted height is still within the max-height, find out the up/down centering margin that is needed
                                var remainingHeight = maxHeight - adjustedHeight,
                                    topBottomMargin = (remainingHeight / 2) + 'px';

                                $(image).css({
                                    'height': 'auto',
                                    'width': '100%',
                                    'max-width': '100%',
                                    'margin': topBottomMargin + ' auto'
                                });

                            }

                        } else {

                            // If the image is portrait or square, set the height to full height and center it
                            $(image).css({ 'height': maxHeight, 'width': 'auto', 'max-width': '100%', 'margin': '0 auto' });

                        }

                    } else {

                        // On mobile, set all images to full width, height auto
                        $(image).css({ 'height': 'auto', 'width': '100%' });

                    }

                });

                $('.hunting-slideshow-thumbnail-item').on('click', function () {
                    var imageIndex = $(this).data('image-index');
                    $('#hunting-photo-gallery-modal').modal('show');

                    setTimeout(function () {
                        huntingPhotoGallerySlideshow.slick('slickGoTo', imageIndex);
                    }, 500);
                });

                $('#hunting-photo-gallery-modal-thumbnails').on('shown.bs.modal', function () {
                    $('.hunting-slideshow-thumbnail-item .image-background-container').each(function () {
                        if (!$(this).hasClass('image-has-been-loaded')) {
                            $(this).css('background-image', 'url("' + $(this).data('image-to-load') + '")');
                            $(this).addClass('image-has-been-loaded');
                        }
                    });

                    window.helpers.updateUrl('hunting-gallery', 'true');

                    window.helpers.gaEvent('Property Detail', 'view-hunting-gallery', propertyIdParameter);
                });

                $('#hunting-photo-gallery-modal-thumbnails').on('hidden.bs.modal', function () {
                    window.helpers.updateUrl('hunting-gallery', 'false');
                });

                $('#hunting-photo-gallery-modal').on('shown.bs.modal', function () {
                    $('#property-hero').addClass('gallery-is-open hunting-gallery-is-open');

                    if (!huntingGalleryIsLoaded) {
                        setTimeout(function () {
                            huntingPhotoGallerySlideshow.slick('setPosition', 0);
                        }, 500);
                        huntingGalleryIsLoaded = true;
                    }
                });

                $('#hunting-photo-gallery-modal').on('hidden.bs.modal', function () {
                    $('#property-hero').removeClass('gallery-is-open hunting-gallery-is-open');
                    $('body').removeClass('modal-open');
                });
            });
        }

    }

    /**
     * Brokers
     */
    let brokerReadBioButton = $('.broker-read-bio-btn'),
        brokerBioModal = $('#broker-bio-modal'),
        brokerBioModalContents = $('#broker-bio-contents'),
        brokerContactButton = $('.broker-contact-button'),
        brokerContactModal = $('#broker-contact-modal'),
        brokerContactForm = $('#broker-contact-form'),
        brokerContactThankYouInput = $('#broker-contact-thank-you'),
        brokerContactThankYouModal = $('#broker-contact-thank-you-modal');





    brokerReadBioButton.on('click', function () {
        // brokerBioModalContents.html($(this).data('bio-content'));
    });

    brokerContactButton.on('click', function () {
        window.broker_name = $(this).data('broker-name');
        window.listing_id = $(this).data('listing-id');
        $('#contact-broker-id').val($(this).data('broker-id'));
        $('#contact-broker-label').val($(this).data('broker-label'));
        $('#contact-broker-heading').html("Ask " + $(this).data('broker-label'));
    });

    if (brokerContactModal.length) {
        brokerContactForm.validate({
            rules: {
                contact_first_name: "required",
                contact_last_name: "required",
                contact_email_address: { required: true, email: true },
                contact_details: "required"
            },
            submitHandler: function (form) {
                grecaptcha.execute();
            }
        });
    }

    if (brokerContactThankYouInput.length) {
        brokerContactThankYouModal.modal('show');

        // get url parameter broker
        var broker = window.helpers.getQueryVariable('broker');

        console.log('sending broker-contact-submit event');
        console.log($('#contact-property-label').val());
        console.log(broker);

        window.dataLayer.push({
            event: 'broker-contact-submit',
            brokerLabel: (broker) ? broker : '',
            propertyLabel: $('#contact-property-label').val(),
        });
    }

    // TODO: Correct these...need to actually pass through details now
    if (window.helpers.getQueryVariable('broker-contact') === "true") {
        if ($('#broker-contact-modal').length) $('#broker-contact-modal').modal('show');
    }

    if (window.helpers.getQueryVariable('broker-contact-2') === "true") {
        if ($('#cobroker-contact-modal').length) $('#cobroker-contact-modal').modal('show');
    }

    // START Tract Slideshows
    if ($('.tract-gallery').length) {

        $('.tract-gallery').each(function () {

            let galleryIsLoaded = false,
                tractId = $(this).data('tract-id');

            $(this).imagesLoaded(function () {

                var photoGallerySlideshow = $('#photo-gallery-slideshow-' + tractId).slick({
                    lazyLoad: 'ondemand',
                    fade: true,
                    prevArrow: '<button type="button" class="slick-prev"><img src="/assets/img/icon-arrow.svg" alt=""></button>',
                    nextArrow: '<button type="button" class="slick-next"><img src="/assets/img/icon-arrow.svg" alt=""></button>',
                    adaptiveHeight: false
                });

                var maxHeight = $(window).height() * .9;

                var checkDialog = $(this).find('.modal-dialog'),
                    slideWidth = checkDialog.actual('width');

                photoGallerySlideshow.on('lazyLoaded', function (event, slick, image, imageSource) {
                    var height = $(image).actual('height'),
                        width = $(image).actual('width');

                    if ($(window).width() > 768) {

                        if (width > height) {

                            // If the image is landscape, proceed with other checks

                            // Check what the new height would be after being resized via a width 100%
                            var adjustedHeight = (slideWidth / width) * height;

                            if (adjustedHeight > maxHeight) {

                                // If the adjusted height is greater than the max-height, set based on height, and not on width
                                $(image).css({ 'height': maxHeight, 'width': 'auto', 'max-width': '100%', 'margin': '0 auto' });

                            } else {

                                // If the adjusted height is still within the max-height, find out the up/down centering margin that is needed
                                var remainingHeight = maxHeight - adjustedHeight,
                                    topBottomMargin = (remainingHeight / 2) + 'px';

                                $(image).css({
                                    'height': 'auto',
                                    'width': '100%',
                                    'max-width': '100%',
                                    'margin': topBottomMargin + ' auto'
                                });

                            }

                        } else {

                            // If the image is portrait or square, set the height to full height and center it
                            $(image).css({ 'height': maxHeight, 'width': 'auto', 'max-width': '100%', 'margin': '0 auto' });

                        }

                    } else {

                        // On mobile, set all images to full width, height auto
                        $(image).css({ 'height': 'auto', 'width': '100%' });

                    }

                });

                $('#photo-gallery-modal-thumbnails-' + tractId).find('.slideshow-thumbnail-item').on('click', function () {
                    var imageIndex = $(this).data('image-index');
                    $('#photo-gallery-modal-' + tractId).modal('show');

                    setTimeout(function () {
                        photoGallerySlideshow.slick('slickGoTo', imageIndex);
                    }, 500);
                });

                $('#photo-gallery-modal-thumbnails-' + tractId).on('shown.bs.modal', function () {
                    $('.slideshow-thumbnail-item .image-background-container').each(function () {
                        if (!$(this).hasClass('image-has-been-loaded')) {
                            $(this).css('background-image', 'url("' + $(this).data('image-to-load') + '")');
                            $(this).addClass('image-has-been-loaded');
                        }
                    });

                    // window.helpers.updateUrl('gallery', 'true');

                    // window.helpers.gaEvent('Property Detail', 'view-gallery', propertyIdParameter);
                });

                $('#photo-gallery-modal-' + tractId).on('shown.bs.modal', function () {
                    $('#property-hero').addClass('gallery-is-open');

                    if (!galleryIsLoaded) {
                        setTimeout(function () {
                            photoGallerySlideshow.slick('setPosition', 0);
                        }, 500);
                        galleryIsLoaded = true;
                    }
                });

                $('#photo-gallery-modal-' + tractId).on('hidden.bs.modal', function () {
                    $('#property-hero').removeClass('gallery-is-open');
                    $('body').addClass('modal-open');
                });
            });

        });

    }
    // END Tract Slideshows



    if($('.tracts-tab-display').length) {

        let tractToggles = $('.tract-details-toggle'),
            tractTitles = $('.tract-information h2');

        tractToggles.on('click', function () {

            // if this parent is an a tag
            if($(this).parent().is('a')) {
                return true;
            }

            let tractDetails = $(this).parent().parent().parent().find('.tract-details');

            if(tractDetails.hasClass('d-none')) {
                tractDetails.removeClass('d-none');
                $(this).addClass('open');
            } else {
                tractDetails.addClass('d-none');
                $(this).removeClass('open');
            }

        });

        tractTitles.on('click', function () {

            let tractDetails = $(this).parent().parent().parent().find('.tract-details'),
                tractToggle = $(this).parent().parent().parent().find('.tract-details-toggle');

            if(tractDetails.hasClass('d-none')) {
                tractDetails.removeClass('d-none');
                tractToggle.addClass('open');
            } else {
                tractDetails.addClass('d-none');
                tractToggle.removeClass('open');
            }

        });

    }
});


function updateUrl(param, value) {
    var newUrl = "";
    if (window.helpers.getQueryVariable(param)) {
        newUrl = window.helpers.updateURLParameter(window.location.href, param, value);
    } else {
        newUrl = window.helpers.addOrReplaceParam(window.location.href, param, value);
    }

    newUrl = window.helpers.cleanUrl(newUrl);

    if (window.helpers.readCookie('current_search_string') !== null) {
        window.helpers.eraseCookie('current_search_string');
    }

    window.helpers.createCookie('current_search_string', newUrl, 1);

    if (window.history.replaceState) {
        window.history.replaceState(null, null, newUrl);
    }
}
